
export const builtInButtons = [
  {
    action() {
      return this.back();
    },
    classes: 'btn btn-link',
    text: 'Назад'
  },
  {
    action() {
      return this.next();
    },
    text: 'Далее',
    classes: 'btn btn-primary',
  }
];
export const builtInButtonBack = [
  {
    action() {
      return this.back();
    },
    classes: 'btn btn-link',
    text: 'Назад'
  }
];
export const defaultStepOptions = {
  classes: 'custom-class-name-1 custom-class-name-2',
  scrollTo: false,
  cancelIcon: {
    enabled: true
  }
};

export const defaultSteps = [
  {
    id: 'intro',
    attachTo: {
      element: '.first-element',
      on: 'bottom'
    },
    /*beforeShowPromise: () => {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve();
        }, 500);
      });
    },*/
    buttons: [
      /*{
        classes: 'shepherd-button-secondary',
        text: 'Exit',
        type: 'cancel'
      },
      {
        classes: 'shepherd-button-primary',
        text: 'Back',
        type: 'back'
      },
      {
        classes: 'shepherd-button-primary',
        text: 'Next',
        type: 'next'
      }*/
    ],
    cancelIcon: {
      enabled: true
    },
    classes: 'custom-class-name-1 custom-class-name-2',
    highlightClass: 'highlight',
    scrollTo: false,
    title: 'Welcome to Angular-Shepherd!',
    text: ['Angular-Shepherd is a JavaScript library for guiding users through your Angular app.'],
    when: {
      show: () => {
        console.log('show step');
      },
      hide: () => {
        console.log('hide step');
      }
    }
  }
];
